<template>
    <div class="px-3 w-100">
        <v-row no-gutters>
            <!-- car -->
            <v-col class="d-flex justify-center align-center pb-3" col="6" sm="3">
                <v-btn
                    class="mx-2"
                    :color="travelExpense.vehiculeType === 'CAR' ? 'primary' : 'grey'"
                    @click="setVehiculeType('CAR')"
                    size="large"
                    icon="$oss-car"
                >
                </v-btn>
            </v-col>

            <!-- moto -->
            <v-col class="d-flex justify-center align-center pb-3" cols="6" sm="3">
                <v-btn
                    :class="'mx-2 '"
                    :color="
                        travelExpense.vehiculeType === 'TWO_REAR_WHEELS_GT_50' ? 'primary' : 'grey'
                    "
                    @click="setVehiculeType('TWO_REAR_WHEELS_GT_50')"
                    size="large"
                    icon="$oss-moto"
                >
                </v-btn>
            </v-col>

            <!-- mob -->
            <v-col class="d-flex justify-center align-center" cols="6" sm="3">
                <v-btn
                    :class="'mx-2'"
                    :color="
                        travelExpense.vehiculeType === 'TWO_REAR_WHEELS_LTE_50' ? 'primary' : 'grey'
                    "
                    @click="setVehiculeType('TWO_REAR_WHEELS_LTE_50')"
                    size="large"
                    icon="$oss-motorcycle"
                >
                </v-btn>
            </v-col>

            <!-- velo -->
            <v-col class="d-flex justify-center align-center" cols="6" sm="3">
                <v-btn
                    :class="$vuetify.display.mobile ? 'mr-1' : 'mx-2'"
                    :color="travelExpense.vehiculeType === 'BICYCLE' ? 'primary' : 'grey'"
                    @click="setVehiculeType('BICYCLE')"
                    size="large"
                    icon="$oss-bicycle"
                >
                </v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <!-- car -->
            <v-col class="d-flex justify-center align-center" col="6" sm="3"> </v-col>

            <!-- moto -->
            <v-col class="d-flex justify-center align-center" cols="6" sm="3"> +50cm&#xb2; </v-col>

            <!-- mob -->
            <v-col class="d-flex justify-center align-center" cols="6" sm="3"> -50cm&#xb2; </v-col>

            <!-- velo -->
            <v-col class="d-flex justify-center align-center" cols="6" sm="3"> </v-col>
        </v-row>
        <v-row
            no-gutters
            v-if="travelExpense.vehiculeType === 'CAR'"
            class="text-center d-flex align-center"
        >
            <v-col
                v-if="$vuetify.display.mobile"
                class="text-center align-center mx-auto mr-2 pt-2"
                cols="12"
            >
                <v-select-filled
                    v-model="travelExpense.power"
                    :items="powerCar"
                    hide-details
                    :readonly="!commonEnableModification"
                    label="Choissisez la puissance"
                    density="compact"
                    item-title="text"
                />
            </v-col>
            <v-col v-else cols="12" class="text-center align-center pl-10">
                <v-btn
                    :class="$vuetify.display.mobile ? 'mr-1' : 'mx-2'"
                    :variant="travelExpense.power >= 4 ? 'outlined' : 'flat'"
                    color="primary"
                    @click="setPower(1)"
                    rounded
                    elevation="0"
                    size="small"
                >
                    {{ $vuetify.display.mobile ? "- de " : "Moins de " }} 4 CV
                </v-btn>
                <v-btn
                    :class="$vuetify.display.mobile ? 'mr-1' : 'mx-2'"
                    :variant="travelExpense.power !== 4 ? 'outlined' : 'flat'"
                    @click="setPower(4)"
                    color="primary"
                    rounded
                    elevation="0"
                    size="small"
                >
                    4 CV
                </v-btn>
                <v-btn
                    :class="$vuetify.display.mobile ? 'mr-1' : 'mx-2'"
                    :variant="travelExpense.power !== 5 ? 'outlined' : 'flat'"
                    @click="setPower(5)"
                    color="primary"
                    rounded
                    elevation="0"
                    size="small"
                >
                    5 CV
                </v-btn>
                <v-btn
                    :class="$vuetify.display.mobile ? 'mr-1' : 'mx-2'"
                    :variant="travelExpense.power !== 6 ? 'outlined' : 'flat'"
                    @click="setPower(6)"
                    color="primary"
                    rounded
                    elevation="0"
                    size="small"
                >
                    6 CV
                </v-btn>
                <v-btn
                    :class="$vuetify.display.mobile ? 'mt-1' : 'mx-2'"
                    :variant="travelExpense.power < 7 ? 'outlined' : 'flat'"
                    @click="setPower(7)"
                    color="primary"
                    rounded
                    elevation="0"
                    size="small"
                >
                    {{ $vuetify.display.mobile ? "+ de " : "PLus de " }} 6 CV
                </v-btn>
            </v-col>
        </v-row>
        <v-row
            v-else-if="travelExpense.vehiculeType === 'TWO_REAR_WHEELS_GT_50'"
            class="text-center d-flex align-center"
            no-gutters
        >
            <v-col
                v-if="$vuetify.display.mobile"
                class="text-center align-center mx-auto mr-2 pt-2"
                cols="12"
            >
                <v-select-filled
                    v-model="travelExpense.power"
                    :items="powerTwoWheels"
                    hide-details
                    :readonly="!commonEnableModification"
                    label="Choissisez la puissance"
                    density="compact"
                    item-title="text"
                />
            </v-col>
            <v-col v-else cols="12" class="text-center align-center pl-10">
                <v-btn
                    :class="$vuetify.display.mobile ? 'mr-1' : 'mx-2'"
                    :variant="travelExpense.power >= 3 ? 'outlined' : 'flat'"
                    @click="setPower(1)"
                    color="primary"
                    rounded
                    elevation="0"
                    size="small"
                >
                    {{ $vuetify.display.mobile ? "- de " : "Moins de " }} 3 CV
                </v-btn>
                <v-btn
                    :class="$vuetify.display.mobile ? 'mr-1' : 'mx-2'"
                    :variant="
                        travelExpense.power < 2 || travelExpense.power > 5 ? 'outlined' : 'flat'
                    "
                    @click="setPower(4)"
                    color="primary"
                    rounded
                    elevation="0"
                    size="small"
                >
                    entre 3 et 5 CV
                </v-btn>
                <v-btn
                    :class="$vuetify.display.mobile ? 'mt-1' : 'mx-2'"
                    :variant="travelExpense.power < 6 ? 'outlined' : 'flat'"
                    @click="setPower(6)"
                    color="primary"
                    rounded
                    elevation="0"
                    size="small"
                >
                    {{ $vuetify.display.mobile ? "+ de " : "Plus de " }} 5 CV
                </v-btn>
            </v-col>
        </v-row>

        <v-row
            v-if="['TWO_REAR_WHEELS_GT_50', 'CAR'].includes(travelExpense.vehiculeType)"
            no-gutters
        >
            <v-col cols="12">
                <v-switch
                    :class="'mx-2'"
                    v-model="travelExpense.electricalType"
                    label="Véhicule électrique"
                />
            </v-col>
        </v-row>
        <v-divider class="my-2" />
        <v-card elevation="0">
            <v-card-text class="px-0">
                <v-row no-gutters style="position: relative">
                    <div
                        v-if="isModifiedByUser"
                        class="primary w-full pa-2 d-flex justify-center flex-column"
                    >
                        La distance a été éditée par l'utilisateur, il n'est donc pas possible de
                        renseigner les adresses.
                        <div class="pt-2 font-weight-medium">
                            Repasser la distance à 0 pour pouvoir renseigner les adresses.
                        </div>
                    </div>
                    <template v-else>
                        <v-col cols="12" class="pt-1">
                            <HereAddress
                                :readonly="expenseStatus === 'VALIDATED'"
                                :wordingAddress="originAddress"
                                @coordinates="hereAddressDeparture($event)"
                                label="Adresse de départ"
                                data-cy="ExpenseReportAddress-depart"
                            />
                        </v-col>
                        <v-col cols="12" class="pt-1">
                            <HereAddress
                                :readonly="expenseStatus === 'VALIDATED'"
                                :wordingAddress="destinationAddress"
                                @coordinates="hereAddressArrival($event)"
                                label="Adresse d'arrivée"
                                data-cy="ExpenseReportAddress-arrivee"
                            />
                        </v-col>
                    </template>
                </v-row>
            </v-card-text>
        </v-card>
        <v-row no-gutters class="d-flex">
            <v-col class="d-flex align-center flex-grow-1 flex-shrink-0">
                <v-divider />
            </v-col>
            <v-col class="d-flex justify-center flex-grow-0 flex-shrink-1 font-weight-bold px-2">
                OU
            </v-col>
            <v-col class="d-flex align-center flex-grow-1 flex-shrink-0">
                <v-divider />
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex mb-2 align-center">
            <v-col class="flex-grow-1 flex-shrink-0 align-center">
                <oss-text-field-filled
                    outlined
                    cols="4"
                    :class="{
                        'mr-1 mt-1': true,
                        'mx-2': !$vuetify.display.mobile,
                    }"
                    label="Distance"
                    v-model="travelExpenseDistance"
                    hide-details
                    content-class="mt-2"
                    :suffix="'km'"
                    @update:model-value="onDistanceIsEdited()"
                    :disabled="!commonEnableModification"
                    data-cy="expenseReport-travelExpense-distance"
                />
            </v-col>

            <v-col class="flex-grow-0 flex-shrink-1 align-center" style="display: contents">
                <v-switch
                    :class="$vuetify.display.mobile ? 'mr-1 mt-1 mx-2' : ' mt-3 mx-2'"
                    v-model="travelExpense.switchRoundTrip"
                    label="Aller-Retour"
                    size="small"
                />
            </v-col>
        </v-row>

        <v-divider />

        <v-row no-gutters class="pt-4 px-0 pb-0 d-flex justify-center" >
            <v-col cols="auto" class="px-3" v-if="showTravelExpenseCalculation">
                <v-row no-gutters>
                    <v-col class="d-flex justify-center">
                        Année barème
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col class="d-flex justify-center">
                        <h4>{{ travelExpense.year }}</h4>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="auto"  class="px-3" v-if="showTravelExpenseCalculation">
                <v-row no-gutters>
                    <v-col class="d-flex justify-center">
                        Appliquable aux frais
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col class="d-flex justify-center">
                        <h4>{{ travelExpense.year-1 }}</h4>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="auto" class="px-3" v-if="showTravelExpenseCalculation">
                <v-row no-gutters>
                    <v-col class="d-flex justify-center">
                        Distance * coéfficient
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col class="d-flex justify-center">
                        <h4 v-if="!travelExpense.switchRoundTrip">({{ travelExpenseDistance }} km * {{ coef }})</h4>
                        <h4 v-else>({{ travelExpenseDistance * 2 }} km * {{ coef }})</h4>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="auto" class="px-3" v-if="showTravelExpenseCalculation">
                <v-row no-gutters>
                    <v-col class="d-flex justify-center">
                        Montant fixe
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col class="d-flex justify-center">
                        <h4>+ {{ fixAmount }}</h4>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="auto" class="px-3">
                <v-row no-gutters>
                    <v-col class="d-flex justify-center">
                        Total :
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col class="d-flex justify-center">
                        <h4>
                            {{ newCommonFormatCurrency(travelExpenseAmount, undefined) }}
                        </h4>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import HereAddress from "../HereAddress.vue";
import SelectUser from "../user/SelectUser.vue";
import { getDistance } from "../../services/expenseReportDistance";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { User } from "../../store/store";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        HereAddress,
        SelectUser,
    },
    emits: ["destination", "origin"],
})
export class ExpenseReportAddress extends Vue {
    @Prop() travelExpense!: any;
    @Prop() isOwner!: boolean;
    @Prop() expenseStatus!: string;
    @Prop() year!: number;

    isModifiedByUser: boolean = false;
    distance: number = 0;
    coef: number = 0;
    fixAmount: number = 0;
    localYear: number = 0;

    powerCar = [
        { text: "Moins de 4 CV", value: 1 },
        { text: "4 CV", value: 4 },
        { text: "5 CV", value: 5 },
        { text: "6 CV", value: 6 },
        { text: "plus de 6 CV", value: 7 },
    ];

    powerTwoWheels = [
        { text: "Moins de 3 CV", value: 1 },
        { text: "Entre 3 et 5 CV", value: 4 },
        { text: "Plus de 5 CV", value: 6 },
    ];

    get travelExpenseDistance() {
        if (!this.travelExpense) {
            return 0;
        }
        return this.travelExpense.distance;
    }

    set travelExpenseDistance(data) {
        if (data) {
            this.isModifiedByUser = true;
        }
        this.isModifiedByUser = true;
        this.travelExpense.distance = data;
    }

    get originAddress() {
        if (!this.travelExpense) {
            return "";
        }
        return this.travelExpense.origin?.wordingAddress;
    }

    get destinationAddress() {
        if (!this.travelExpense) {
            return "";
        }
        return this.travelExpense.destination?.wordingAddress;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get commonEnableModification() {
        if (this.currentUser.profile.configuration.expenseReport.writeOnlySelf) {
            if (this.isOwner) {
                return true;
            }
        }
        return this.currentUser.profile.configuration.expenseReport.write;
    }

    async doubleDistance() {
        if (this.travelExpense.switchRoundTrip && this.travelExpense.distance) {
            this.travelExpense.distance = this.travelExpense.distance * 2;
        } else {
            this.travelExpense.distance = this.travelExpense.distance / 2;
        }
    }

    async hereAddressArrival(destination) {
        if (destination) {
            this.$emit("destination", destination);
            await this.computeDistance();
        }
    }

    async hereAddressDeparture(origin) {
        if (origin) {
            this.$emit("origin", origin);
            await this.computeDistance();
        }
    }

    async computeDistance() {
        if (!this.travelExpense.origin?.latitude || !this.travelExpense.origin?.longitude) {
            return;
        }

        if (
            !this.travelExpense.destination?.latitude ||
            !this.travelExpense.destination?.longitude
        ) {
            return;
        }

        const origin = `${this.travelExpense.origin?.latitude},${this.travelExpense.origin?.longitude}`;
        const destination = `${this.travelExpense.destination?.latitude},${this.travelExpense.destination?.longitude}`;

        const payload = {
            origin,
            destination,
            vehiculeType: this.travelExpense.vehiculeType,
        };
        try {
            this.travelExpense.distance = (await getDistance(payload)) / 1000;
        } catch (e) {
            console.log(e);
            debugger;
        }
    }

    get travelExpenseAmount() {
        if (!this.travelExpense.distance) {
            return 0;
        }
        const travelExpenseTable = this.travelExpenseCal();
        let result = {
            travelExpenseAmount: 0,
            coef: 0,
            fixAmount: 0
        };
        let distance = this.travelExpense.distance;
        if (this.travelExpense.switchRoundTrip) {
            distance = distance * 2;
        }
        if (travelExpenseTable !== null) {
            result = travelExpenseTable(
                this.travelExpense.vehiculeType,
                this.travelExpense.power,
                distance,
                this.travelExpense.electricalType,
            );
            this.coef = result.coef;
            this.fixAmount = result.fixAmount;

            return Math.round(result.travelExpenseAmount * 100) / 100;
        } else {
            return 0;
        }
    }

    travelExpenseCal(year = null) {
        if (!this.localYear) {
            this.localYear = this.year;
        }
        if (!year) {
            year = this.localYear;
        }
        // ** this.localYear = millésime applicable ou appliqué à la note de frais
        // ** exemple : en mars/avril 2025 sors le millésime 2025 applicable aux frais km de 2024
        // ** en conséquence, les ndf de 2024, saisies courant 2024, faute de disponibilité du barème applicable, seront calculées avec le barème 2024
        // ** les ndf de 2024, saisie après la publication du barème 2025, seront calculées avec le barème 2025
        // ** Il faudra concevoir un contrôle dans le Dossier de révision, afin de corriger les ndf de 2024 saisies avant la publication du barème 2025, de façon globale (annuelle), mais par collaborateur
        if (!this.travelExpense.year) {
            this.travelExpense.year = year;
        } else {
            if (this.expenseStatus === "VALIDATED") {
                year = this.travelExpense.year
            } else if (this.travelExpense.year && this.travelExpense.year !== year) {
                this.travelExpense.year = year;
                this.localYear = year;
            }
        }

        try {
            const travelExpense = require(
                "../../services/travelExpense/" + year + "-travelExpense",
            );
            return travelExpense.default;
        } catch (e) {
            if (year > 2018) {
                return this.travelExpenseCal(year - 1);
            }
        }
        return null;
    }

    setPower(power: any): void {
        if (this.commonEnableModification) {
            this.travelExpense.power = power;
        }
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    onDistanceIsEdited() {
        if (this.travelExpense.distance) {
            this.isModifiedByUser = true;
            this.travelExpense.origin = null;
            this.travelExpense.destination = null;
        } else {
            this.isModifiedByUser = false;
        }
    }

    setVehiculeType(type) {
        if (this.commonEnableModification) {
            this.travelExpense.vehiculeType = type;
            if (type === "CAR") {
                if (this.travelExpense.power === undefined) {
                    this.travelExpense.power = 1;
                }
            } else if (type === "TWO_REAR_WHEELS_GT_50") {
                if (this.travelExpense.power === undefined) {
                    this.travelExpense.power = 1;
                }
            } else if (type === "TWO_REAR_WHEELS_LTE_50") {
                if (this.travelExpense.power !== undefined) {
                    this.travelExpense.power = 1;
                }
            }
        }
    }

    get showTravelExpenseCalculation() {
        if (!this.travelExpenseAmount) {
            return false;
        }
        // ** at end 2025-01 only 2022-travelExpense.ts was available
        // ** all existing and validated expense reports are calculated with 2022-travelExpense.ts (don't show the calculation)
        // ** all new expenses reports will be calculated with the travelExpense.ts of the current year (if not existing, with previous year)
        if (this.localYear == this.travelExpense.year && this.travelExpense.year !== 2022) {
            return true;
        }

        // ** le barème applicable à N est publié par les impôts en mars de l'année N+1
        // ** donc, les NDF saisies en N sont calculées avec
        if (this.localYear -1 == this.travelExpense.year) {
            return true;
        }
        return false;
    }
}

export default toNative(ExpenseReportAddress);
</script>
